export default __webpack_public_path__ + "static/IOT-41136276051c69549e68d61e9ecea1bb.jpeg";